import { Upload, Search, FileCheck, Zap } from "lucide-react";
import Reveal from "./Reveal";

const steps = [
  {
    n: "01",
    icon: Upload,
    title: "Invia la bolletta",
    text: "Carica la tua bolletta luce o gas tramite il form. Bastano pochi secondi.",
  },
  {
    n: "02",
    icon: Search,
    title: "Analisi senza impegno",
    text: "Studiamo i tuoi consumi e confrontiamo le offerte disponibili sul mercato.",
  },
  {
    n: "03",
    icon: FileCheck,
    title: "Proposta su misura",
    text: "Ti presentiamo la soluzione più conveniente, con costi chiari e trasparenti.",
  },
  {
    n: "04",
    icon: Zap,
    title: "Attivazione",
    text: "Ci occupiamo noi del cambio fornitore: tu non devi fare nulla.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="come-funziona"
      data-testid="how-section"
      className="relative py-24 lg:py-32 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-sage-600">
            Come funziona
          </span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight leading-tight text-forest-900">
            Semplice, in quattro passi.
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <Reveal
                key={step.n}
                delay={i * 0.08}
                className="relative border-t border-sage-300 pt-8"
              >
                <div className="flex items-center justify-between">
                  <span className="font-serif text-5xl text-sage-400 leading-none">
                    {step.n}
                  </span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage-100 text-forest-700">
                    <Icon className="h-5 w-5" strokeWidth={1.7} />
                  </span>
                </div>
                <h3 className="mt-6 font-sans text-xl font-medium text-forest-800">
                  {step.title}
                </h3>
                <p className="mt-3 text-base font-light text-forest-700 leading-relaxed">
                  {step.text}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
